import React, {Component} from 'react';
import anime from 'animejs';
import PropTypes from 'prop-types';
import Utils from './utils.js';

const fills = [
    '#ef6e7e',
    // '#a47ddd',
    '#ee754d',
    '#109181',
    '#3CBBB1',
    '#118AB2',
    // '#103c91',
    '#efc36e',
];

class LoadHandler {
    constructor() {
        this.toLoad = {};
        this.callback = null;
        this.resetCallback = null;
        this.loadComplete = null;

        this.fill = '#fff';
        this.invertFill = '#000';

        this.reset = this.reset.bind(this);
        this.registerToLoad = this.registerToLoad.bind(this);
        this.registerLoad = this.registerLoad.bind(this);
        this.loaded = this.loaded.bind(this);
        this.setUpdateCallback = this.setUpdateCallback.bind(this);
        this.setResetCallback = this.setResetCallback.bind(this);
    }

    reset(callback) {
        this.toLoad = {};

        if (this.resetCallback !== null) {
            this.resetCallback(callback);
        }
    }

    setResetCallback(callback) {
        this.resetCallback = callback;
    }

    setUpdateCallback(callback) {
        this.callback = callback;
    }

    registerToLoad(uuid) {
        this.toLoad[uuid] = false;

        if (this.callback !== null) {
            this.callback();
        }
    }

    registerLoad() {
        let uuid = Utils.generateUID(7);
        this.registerToLoad(uuid);
        return uuid;
    }

    loaded(uuid) {
        if (this.toLoad.hasOwnProperty(uuid)) {
            this.toLoad[uuid] = true;

            if (this.callback !== null) {
                this.callback();
            }
        }
    }
}

let loadHandler = new LoadHandler();

class Loader extends Component {
    constructor(props) {
        super(props);
        this.logo = React.createRef();
        this.wrapper = React.createRef();

        // this.reset = this.reset.bind(this);
        // this.registerToLoad = this.registerToLoad.bind(this);
        // this.loaded = this.loaded.bind(this);
        this.updateProgress = this.updateProgress.bind(this);
        this.animateProgress = this.animateProgress.bind(this);
        this.reset = this.reset.bind(this);
        this.rerollFill = this.rerollFill.bind(this);
        this.postFillRoll = this.postFillRoll.bind(this);

        loadHandler.setUpdateCallback(this.updateProgress);
        loadHandler.setResetCallback(this.reset);
    }

    render() {
        return(
            <header className="ip-header" ref={this.wrapper}>
                <div className="ip-logo">

                    <svg id="ip-logo" className="ip-inner" width="100%" height="100%" viewBox="0 0 500 500"
                         preserveAspectRatio="xMidYMin meet" aria-labelledby="logo_title" ref={this.logo}>
                        <defs>
                            <clipPath id="logo-clip">
                                <path d="M474.6,195.4h-171L388.7,28L474.6,195.4z"/>

                                <path d="M25.4,195.4V28.5h170.7L110.4,112l85.1,83.4H25.4z"/>

                                <path d="M473.8,305.2v83.4c0,12.1-2.1,23.2-6.4,33.4c-4.3,10.2-10.2,19-17.7,26.4c-7.6,7.4-16.5,13.2-26.9,17.4
			c-10.4,4.2-21.7,6.3-34,6.3c-12.3,0-23.6-2.1-34-6.3c-10.4-4.2-19.4-10-26.9-17.4c-7.6-7.4-13.5-16.2-17.7-26.4
			c-4.3-10.2-6.4-21.3-6.4-33.4v-83.4H473.8z"/>

                                <path d="M25.4,472V304.6h84.5c13.6,0,25.8,1.6,36.4,4.9c10.7,3.2,19.7,7.5,27.1,12.8c7.4,5.3,12.9,11.3,16.7,18.1
			c3.8,6.8,5.6,13.6,5.4,20.4c0,9.5-3.3,18.5-9.9,27.3c-6.4,8.5-22.5,17.9-48.2,28.1l54.7,55.9H25.4z"/>
                            </clipPath>
                        </defs>
                        <rect id="logo-fill" x="0" y="100%" width="100%" height="100%"
                              clipPath="url(#logo-clip)"/>
                        <g id="logo-outline">
                            <path id="k" d="M25.4,195.4V28.5h170.7L110.4,112l85.1,83.4H25.4z"/>
                            <path id="a" d="M474.6,195.4h-171L388.7,28L474.6,195.4z"/>
                            <path id="r" d="M25.4,472V304.6h84.5c13.6,0,25.8,1.6,36.4,4.9c10.7,3.2,19.7,7.5,27.1,12.8c7.4,5.3,12.9,11.3,16.7,18.1
			c3.8,6.8,5.6,13.6,5.4,20.4c0,9.5-3.3,18.5-9.9,27.3c-6.4,8.5-22.5,17.9-48.2,28.1l54.7,55.9H25.4z"/>
                            <path id="u" d="M473.8,305.2v83.4c0,12.1-2.1,23.2-6.4,33.4c-4.3,10.2-10.2,19-17.7,26.4c-7.6,7.4-16.5,13.2-26.9,17.4
			c-10.4,4.2-21.7,6.3-34,6.3c-12.3,0-23.6-2.1-34-6.3c-10.4-4.2-19.4-10-26.9-17.4c-7.6-7.4-13.5-16.2-17.7-26.4
			c-4.3-10.2-6.4-21.3-6.4-33.4v-83.4H473.8z"/>
                        </g>
                    </svg>
                </div>
            </header>
        )
    }

    rerollFill() {
        let fill = fills[Math.floor(Math.random() * fills.length)];
        while (fill === loadHandler.fill) {
            fill = fills[Math.floor(Math.random() * fills.length)];
        }
        document.querySelectorAll('.ip-logo #logo-outline path').forEach((el) => {
            el.style.stroke = fill;
        });
        document.querySelector('.ip-logo #logo-fill').style.fill = fill;

        this.props.onFill(fill);
        loadHandler.fill = fill;
        loadHandler.invertFill = Utils.invertColor(fill);
    }

    postFillRoll() {
        let body = document.querySelector('body');
        // body.style.background = "url(data:image/png;base64,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)";
        body.style.backgroundColor = loadHandler.fill;

    }

    componentDidMount() {
        this.rerollFill();
        this.postFillRoll();
        anime({
            targets: this.logo.current,
            scale: 0.8,
            duration: 300,
            easing: 'easeInOutBack',
        });
    }

    reset(callback) {
        this.rerollFill();
        anime({
            targets: this.logo.current,
            opacity: 1,
            easing: 'cubicBezier(0.7,0,0.3,1)',
        });
        anime({
            targets: this.logo.current.querySelector('#logo-fill'),
            y: 100 + '%',
            easing: 'cubicBezier(0.7,0,0.3,1)',
            duration: 0,
        });
        anime({
            targets: this.wrapper.current,
            translateY: 0,
            easing: 'cubicBezier(0.7,0,0.3,1)',
            complete: () => {
                this.postFillRoll();
                callback();
            }
        });
    }

    updateProgress() {
        // console.log(loadHandler.toLoad);
        let total = 0;
        let completed = 0;
        Object.keys(loadHandler.toLoad).forEach((key) => {
            if (loadHandler.toLoad[key] === true) {
                completed += 1;
            }
            total += 1;
        });

        let percent = completed / total * 100;

        this.animateProgress(percent);
    }

    animateProgress(percent) {
        if (percent >= 100) {
            percent = 100;
        }
        let targ = this.logo.current.querySelector('#logo-fill');
        if (targ != null)  anime.remove(targ);

        anime({
            targets: this.logo.current.querySelector('#logo-fill'),
            y: 100 - percent + '%',
            easing: 'cubicBezier(0.7,0,0.3,1)',
            complete: () => {
                if (percent >= 100) {
                    anime.remove(this.logo.current);
                    anime.remove(this.wrapper.current);
                    anime.timeline().add({
                        targets: this.logo.current,
                        opacity: 0,
                        duration: 800,
                    }, "+=300").add({
                        targets: this.wrapper.current,
                        translateY: -100 + '%',
                        duration: 1000,
                        easing: 'cubicBezier(0.7,0,0.3,1)',
                        complete: () => {
                            if (loadHandler.loadComplete != null) {
                                loadHandler.loadComplete();
                            }
                            // anime({
                            //     targets: this.wrapper.current,
                            //     translateY: 100 + '%',
                            //     easing: 'cubicBezier(0.7,0,0.3,1)',
                            //     duration: 0,
                            // });
                        }
                    })
                }
            }
        });
    }
}

Loader.propTypes = {
    onFill: PropTypes.func,
};

export default Loader;
export {loadHandler};